import createIcon from '../../createIcon';

/**
 * @component @name HeadsetMic
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMUM3LjAzIDEgMyA1LjAzIDMgMTBWMTdDMyAxOC42NiA0LjM0IDIwIDYgMjBIOVYxMkg1VjEwQzUgNi4xMyA4LjEzIDMgMTIgM0MxNS44NyAzIDE5IDYuMTMgMTkgMTBWMTJIMTVWMjBIMTlWMjFIMTJWMjNIMThDMTkuNjYgMjMgMjEgMjEuNjYgMjEgMjBWMTBDMjEgNS4wMyAxNi45NyAxIDEyIDFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HeadsetMic = createIcon('HeadsetMic', [
  [
    'path',
    {
      d: 'M12 1C7.03 1 3 5.03 3 10V17C3 18.66 4.34 20 6 20H9V12H5V10C5 6.13 8.13 3 12 3C15.87 3 19 6.13 19 10V12H15V20H19V21H12V23H18C19.66 23 21 21.66 21 20V10C21 5.03 16.97 1 12 1Z',
      key: '1q1wj9',
    },
  ],
]);

export default HeadsetMic;
